import { render, staticRenderFns } from "./PermissionTable.vue?vue&type=template&id=1c1e64c9&scoped=true&"
import script from "./PermissionTable.vue?vue&type=script&lang=js&"
export * from "./PermissionTable.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTable.vue?vue&type=style&index=0&id=1c1e64c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e64c9",
  null
  
)

export default component.exports